import get from 'lodash/get';
import { combineReducers } from 'redux';
import { createReducer } from 'redux-act';
import { createSelector } from 'reselect';
import { createResource } from '@gandi/resource/redux';
import { baseUrl as moduleBaseUrl, statePath as moduleStatePath } from '../utils';
export const AUTO_RENEW_UNIT_MONTH = 'm';
export const AUTO_RENEW_UNIT_YEAR = 'y';
export const statePath = `${moduleStatePath}.autorenew`;
export const baseUrl = `${moduleBaseUrl}/instances`;
export const resourceName = 'resources-simplehosting.autorenew';
export const resource = createResource(resourceName);
export const fetchOne = (instanceId, options = {}) => dispatch => dispatch(resource.fetchOne(`${baseUrl}/${instanceId}/autorenew`, {
  label: instanceId,
  ...options
}));
export const patch = (instanceId, payload, options = {}) => dispatch => dispatch(resource.patchOne(`${baseUrl}/${instanceId}/autorenew`, payload, {
  label: instanceId,
  on2XX: response => response,
  not2XX: response => Promise.reject(response),
  ...options
}));
export const invalidate = () => dispatch => dispatch(resource.invalidate());
export const initialState = {
  details: {}
};
export const handleFetchOneSuccess = (state, payload) => ({
  ...state,
  [payload.label]: payload.response.data
});
export const detailsReducer = createReducer({
  [resource.fetchOne.success.getType()]: handleFetchOneSuccess
}, initialState.details);
export const reducer = combineReducers({
  details: detailsReducer
});
const selectRawState = state => get(state, statePath, {});
export const selectRawDetails = createSelector([selectRawState], raw => raw.details);
export const selectDetail = createSelector([selectRawDetails, (_, instanceId) => instanceId], (raw, instanceId) => raw[instanceId]);
export const selectIsFetchingOne = (state, instanceId) => resource.selectIsFetchingOne(state, instanceId);
export const selectIsLoadedOne = (state, instanceId) => resource.selectIsLoadedOne(state, instanceId);
export const selectIsFailureOne = (state, instanceId) => resource.selectIsFailureOne(state, instanceId);
export const selectIsNotFoundOne = (state, instanceId) => resource.selectIsFailureOne(state, {
  label: instanceId,
  status: 404
});
export const selectIsToRefetchOne = (state, instanceId) => resource.selectIsToRefetchOne(state, instanceId);
export const selectIsPatchingOne = (state, instanceId) => resource.selectIsPatchingOne(state, instanceId);